const STAGE_COUNT = 10;
const STAGE_TOGGLE_KEYS = Array.from({ length: STAGE_COUNT }, (_, i) => `stage${i + 1}`);

export function parseStageToggle(raw) {
  return raw === 'true' || raw === true;
}

/** Theme payload stage1–stage10 as "true" / "false" strings (themeset format). */
export function stageTogglesFromTheme(themeData) {
  return Object.fromEntries(
    STAGE_TOGGLE_KEYS.map((key) => [
      key,
      parseStageToggle(themeData?.[key] ?? 'true') ? 'true' : 'false',
    ])
  );
}
